import React, { useState } from "react";
import { NavLink } from 'react-router-dom';

import classes from './ArticlePost.module.css';
import ModalVideo from "react-modal-video";
import VideoButton from "../VideoButton/VideoButton"

interface ArticlePostInterface {
    postsToRender: any;
    style?: React.CSSProperties;
}

const ArticlePost = ({ postsToRender, style }: ArticlePostInterface) => {
    const [modal, setModal] = useState(false);
    return (
        <>
            <div style={style} className={classes.articleWrapper}>
                <div className={classes.contentWrapper}>
                    <div className={classes.articleHeadingSection}>
                        <NavLink to={`/proverejnost/${postsToRender.slug}`} className={classes.a}>
                            <p className={classes.articleHeading} dangerouslySetInnerHTML={{
                                __html: postsToRender.headline
                            }} />
                        </NavLink>
                        <VideoButton style={{ marginBottom: "auto", marginTop: "1rem" }} setModal={setModal} />
                    </div>
                    <NavLink to={`/proverejnost/${postsToRender.slug}`} className={classes.a}>
                        <div className={classes.articleText} dangerouslySetInnerHTML={{
                            __html: postsToRender.pars[0].content
                        }} />
                    </NavLink>

                </div>
            </div>
            <ModalVideo youtube={{ autoplay: 1, mute: 1 }} channel='youtube' isOpen={modal} videoId={postsToRender.video_code} onClose={() => setModal(false)} />
        </>

    );
};

export default ArticlePost;